import apiClient from './apiClient';

export const getUserByAccountNumber = (accountNumber) => {
  return apiClient.get(`/staff/users/account/${accountNumber}`);
};

// Transactions
export const updateAmount = (accountNumber, data) => {
  return apiClient.post(`/staff/transactions/${accountNumber}`, data);
};


export const getMyTransactions = (type = "today") => {
  return apiClient.get('/staff/transactions', {
    params: { type }
  });
};
